<ion-header>
  <ion-toolbar>
    <img src="assets/icon/cona-bw.png" alt="cona icon" slot="start" />

    <ion-buttons slot="end">
      <!-- FAQ / Help Button -->
      <app-cona-tooltip text="Help & FAQ" position="left-center">
        <ion-button class="faq-icon-btn" shape="round" fill="clear" (click)="openFaqModal()" aria-label="Help and FAQ">
          <ion-icon slot="start" name="help-circle-outline"></ion-icon>
          <span class="faq-btn-text">Help & FAQ</span>
        </ion-button>
      </app-cona-tooltip>

      <ion-button class="profile" shape="round" (click)="togglePopover($event)">
        @if (avatar) {
          <img [src]="avatar" alt="profile img" />
        }
        <div slot="start" #avatarHolder></div>
        <span>{{ userName }}</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- Profile Popover -->
@if (showPopover) {
  <ion-popover
    [isOpen]="showPopover"
    (didDismiss)="closePopover()"
    class="profile-popover"
    style="padding: 16px 0"
    >
    <ng-template>
      <ion-content>
        <ion-list class="profile-dropdown">
          <ion-item lines="none" class="no-right-padding">
            <div class="profile-details">
              <ion-avatar>
                @if (avatar) {
                  <img style="min-height: 100%; width: auto !important" [src]="avatar" alt="profile img" />
                }
                <div style="min-height: 68px; width: 68px !important" #avatarInnerHolder></div>
              </ion-avatar>
              <ion-label>
                <h2>{{ userName }}</h2>
                <p class="email">{{ userEmail }}</p>
                <p>{{ userPhone }}</p>
              </ion-label>
            </div>
          </ion-item>
          <ion-item lines="none" (click)="logout()" class="actionable-item">
            <ion-icon name="log-out-outline"></ion-icon>
            <ion-label style="margin: 2px">Log Out</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ng-template>
  </ion-popover>
}
